import { render, staticRenderFns } from "./PmtaCampaignStatistics.vue?vue&type=template&id=2770480b&scoped=true"
import script from "./PmtaCampaignStatistics.vue?vue&type=script&lang=js"
export * from "./PmtaCampaignStatistics.vue?vue&type=script&lang=js"
import style0 from "./PmtaCampaignStatistics.vue?vue&type=style&index=0&id=2770480b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2770480b",
  null
  
)

export default component.exports